import { Vue } from './config'

if (document.getElementById('v-market')) {
    new Vue({
        el: '#v-market',
        data: {
            timestamp: 'loading...',
            prices: {
                gold: {
                    bid: null,
                    ask: null
                },
                silver: {
                    bid: null,
                    ask: null
                },
                platinum: {
                    bid: null,
                    ask: null
                },
                palladium: {
                    bid: null,
                    ask: null
                }
            }
        },
        methods: {
            getPrices() {
                let self = this
                self.doPost('/Umbraco/Api/Pricing/GetSpotPrices', null, (data) => {
                    self.timestamp = data.marketDateFormat
                    //set prices
                    self.prices.gold.bid = data.spotPrices.filter(item => item.id === 1)[0].priceFormat
                    self.prices.gold.ask = data.spotPrices.filter(item => item.id === 2)[0].priceFormat
                    self.prices.silver.bid = data.spotPrices.filter(item => item.id === 3)[0].priceFormat
                    self.prices.silver.ask = data.spotPrices.filter(item => item.id === 4)[0].priceFormat
                    self.prices.platinum.bid = data.spotPrices.filter(item => item.id === 5)[0].priceFormat
                    self.prices.platinum.ask = data.spotPrices.filter(item => item.id === 6)[0].priceFormat
                    self.prices.palladium.bid = data.spotPrices.filter(item => item.id === 7)[0].priceFormat
                    self.prices.palladium.ask = data.spotPrices.filter(item => item.id === 8)[0].priceFormat
                    self.scheduleUpdate(300000)
                })
            },
            scheduleUpdate(waitInterval) {
                let self = this
                setTimeout(function () { self.getPrices() }, waitInterval)
            }
        },
        mounted() {
            this.getPrices()
        }
    })
}